export function logPrincipalV823(name, id) {
  const displayName = String(name || '').trim();
  const identity = String(id ?? '');
  if (/^[1-9]\d*$/.test(identity)) {
    return displayName ? `${displayName} (#${identity})` : `#${identity}`;
  }
  return displayName || '—';
}
